export const CONFIG = {
  "PROJECTNAME": "dutcheys",
  "COMPANYNAME": "Dutcheys",
  "DFTLNGCODE": "nl",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10126003",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": true,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "#f05b22",
    "primary100": "#F2CECC",
    "light": "#f05b22",
    "secondary": "#f05b22",
    "dark": "#009EE2",
    "siteColor3": "#fff",
    "menuSecondary": "#f05b22"
  }
};